import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Mail, Phone, MapPin, Instagram, Facebook, Youtube } from 'lucide-react';
import { TikTokIcon } from './TikTokIcon';
export function Contact() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  return <section id="contact" className="py-20 bg-white" data-id="element-92">
      <div className="container mx-auto px-4" data-id="element-93">
        <div className="text-center mb-12" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-95">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-96"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-97">
            Have questions or need prayer? Reach out to us and we'll get back to
            you as soon as possible.
          </p>
        </div>

        <div ref={ref} className={`grid md:grid-cols-2 gap-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-98">
          <div data-id="element-99">
            <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-100">
              Get in Touch
            </h3>
            <div className="space-y-4 mb-8" data-id="element-101">
              <div className="flex items-start" data-id="element-102">
                <div className="bg-pink-100 rounded-full p-2 mr-4" data-id="element-103">
                  <Mail size={20} className="text-pink-600" data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <h4 className="font-medium text-gray-800" data-id="element-106">Email</h4>
                  <p className="text-gray-600" data-id="element-107">shewinsintlministry@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-108">
                <div className="bg-pink-100 rounded-full p-2 mr-4" data-id="element-109">
                  <Phone size={20} className="text-pink-600" data-id="element-110" />
                </div>
                <div data-id="element-111">
                  <h4 className="font-medium text-gray-800" data-id="element-112">Phone</h4>
                  <p className="text-gray-600" data-id="element-113">09155020551</p>
                  <p className="text-gray-600" data-id="element-114">08115773583</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-115">
                <div className="bg-pink-100 rounded-full p-2 mr-4" data-id="element-116">
                  <MapPin size={20} className="text-pink-600" data-id="element-117" />
                </div>
                <div data-id="element-118">
                  <h4 className="font-medium text-gray-800" data-id="element-119">Address</h4>
                  <p className="text-gray-600" data-id="element-120">
                    19, Shipeolu Street, Elediye Bustop,
                    <br data-id="element-121" />
                    Onipan. Lagos Nigeria.
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-122">Follow Us</h3>
            <div className="flex space-x-4" data-id="element-123">
              <a href="https://www.instagram.com/shewins_intlministry?igsh=MXh2aGU3eWNqaXluaw==" target="_blank" rel="noopener noreferrer" className="bg-pink-100 hover:bg-pink-200 text-pink-600 p-3 rounded-full transition-colors duration-200" aria-label="Instagram" data-id="element-124">
                <Instagram size={20} data-id="element-125" />
              </a>
              <a href="https://www.facebook.com/share/1DAUTFBUTy/" target="_blank" rel="noopener noreferrer" className="bg-pink-100 hover:bg-pink-200 text-pink-600 p-3 rounded-full transition-colors duration-200" aria-label="Facebook" data-id="element-126">
                <Facebook size={20} data-id="element-127" />
              </a>
              <a href="https://youtube.com/@shewinsintlministry?si=IFQ2JNaBdLNMRnNI" target="_blank" rel="noopener noreferrer" className="bg-pink-100 hover:bg-pink-200 text-pink-600 p-3 rounded-full transition-colors duration-200" aria-label="Youtube" data-id="element-128">
                <Youtube size={20} data-id="element-129" />
              </a>
              <a href="https://www.tiktok.com/@shewins_intlministry?_r=1&_t=ZS-91OdsttK9bB" target="_blank" rel="noopener noreferrer" className="bg-pink-100 hover:bg-pink-200 text-pink-600 p-3 rounded-full transition-colors duration-200" aria-label="TikTok" data-id="element-130">
                <TikTokIcon size={20} data-id="element-131" />
              </a>
            </div>
          </div>

          <div data-id="element-132">
            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-133">
              <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-134">
                Send a Message
              </h3>
              <form className="space-y-4" data-id="element-135">
                <div data-id="element-136">
                  <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-137">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="Your Name" data-id="element-138" />
                </div>
                <div data-id="element-139">
                  <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-140">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="your@email.com" data-id="element-141" />
                </div>
                <div data-id="element-142">
                  <label htmlFor="subject" className="block text-gray-700 mb-2" data-id="element-143">
                    Subject
                  </label>
                  <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="Subject" data-id="element-144" />
                </div>
                <div data-id="element-145">
                  <label htmlFor="message" className="block text-gray-700 mb-2" data-id="element-146">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-600" placeholder="Your message here..." data-id="element-147"></textarea>
                </div>
                <div data-id="element-148">
                  <button type="submit" className="w-full bg-pink-600 hover:bg-pink-700 text-white font-medium py-3 px-4 rounded-md transition-colors duration-200" data-id="element-149">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}